import axios from "axios";
import {ChatStatusResolved} from "../../services/chat/const";
import {localStorageSet, ROOMS_FILTER_QUERY, ROOMS_FILTER_STATUS, ROOMS_FILTER_TYPE} from "../../localStorage";

const LIST_TARGET_BASE = 'base';
const LIST_TARGET_SEARCH = 'search';

export const state = {
  wsConnect: false,

  setting: {
    tenant_id: '',
    contact_group_id: '',
    assign_user_id: '',
    auto_response_enabled: false,
    auto_response_text: '',
    reassign_notify_enabled: false,
    reassign_notify_text: '',
    fast_answers: [],
  },

  counters: {
    all: {all: null, user: null},
    status_resolved: {all: null, user: null},
    assigned_me: {all: null, user: null},
  },

  selectedRoomId: '',
  showRoom: false,
  loading: true,
  rooms: {},
  listBase: [],
  listSearch: [],
  fetchFilter: {
    type: 'all',
    status: 'all',
    query: '',
  },
};

export const mutations = {
  RESET_LISTS(state) {
    state.listBase = [];
    state.listSearch = [];
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_LIST_BASE(state, roomIds) {
    state.listBase = state.listBase.concat(...(roomIds || [])).filter((v, i, s) => s.indexOf(v) === i);
  },
  SET_LIST_CHAT(state, rooms) {
    state.listSearch = state.listSearch.concat(...(rooms || []));
  },
  SET_ROOMS(state, rooms) {
    state.rooms = {
      ...state.rooms,
      ...rooms.reduce(
        (r, room) => {
          r[room.id] = room;
          if (r[room.id] && r[room.id].message_last && r[room.id].message_last.created_at){
            r[room.id].message_last.created_at = (
              typeof room.message_last.created_at === 'string' ?
                Date.parse(room.message_last.created_at) :
                room.message_last.created_at
            );
          }
          return r;
        }, {}),
    };
  },
  SET_SELECTED_ROOM_ID(state, id) {
    state.selectedRoomId = id;
  },
  SET_SHOW_ROOM(store) {
    store.showRoom = true;
  },
  SET_HIDE_ROOM(store) {
    store.showRoom = false;
  },
  SET_WS_CONNECT(store, enabled) {
    store.wsConnect = enabled;
  },
  SET_SETTING(store, setting) {
    store.setting = {
      ...store.setting,
      ...setting,
    };
  },
  READ_MESSAGE(store, {chat_id}) {
    const chat = store.rooms[chat_id];
    if (!chat) return;

    let count_new_messages = chat.count_new_messages - 1;
    if (count_new_messages < 0) count_new_messages = 0;

    store.rooms = {
      ...store.rooms,
      [chat_id]: {
        ...store.rooms[chat_id],
        count_new_messages,
      },
    };
  },
  UNREAD_MESSAGE(store, {chat_id}) {
    const chat = store.rooms[chat_id];
    if (!chat) return;

    const count_new_messages = chat.count_new_messages + 1;

    store.rooms = {
      ...store.rooms,
      [chat_id]: {
        ...store.rooms[chat_id],
        count_new_messages,
      },
    };
  },
  SET_COUNTERS(store, {name, counters}) {
    store.counters = {
      ...store.counters,
      [name]: {...store.counters[name], ...counters},
    };
  },
  SET_FILTER_TYPE(store, type) {
    store.fetchFilter.type = type;
    localStorageSet(ROOMS_FILTER_TYPE, type);
  },
  SET_FILTER_STATUS(store, status) {
    store.fetchFilter.status = status;
    localStorageSet(ROOMS_FILTER_STATUS, status);
  },
  SET_FILTER_QUERY(store, query) {
    store.fetchFilter.query = query;
    localStorageSet(ROOMS_FILTER_QUERY, query);
  },
  ADD_MESSAGE_LAST(state, message_last) {
    state.rooms = {
      ...state.rooms,
      [message_last.chat_id]: {
        ...state.rooms[message_last.chat_id],
        message_last: {
          ...message_last,
          created_at: Date.parse(message_last.created_at),
        },
      },
    };
  },
};

export const getters = {
  room(state) {
    return state.rooms[state.selectedRoomId];
  },
  listBaseOrder: state => {
    return state.listBase
      .map(id => state.rooms[id])
      .sort((a, b) => {
        const aVal = a.message_last || {created_at: 0};
        const bVal = b.message_last || {created_at: 0};

        if (!!a.count_new_messages > !!b.count_new_messages) {
          return -1;
        } else if (!!a.count_new_messages < !!b.count_new_messages) {
          return 1;
        }

        if (aVal.created_at > bVal.created_at) {
          return -1;
        } else if (aVal.created_at < bVal.created_at) {
          return 1;
        }

        return 0;
      })
      .map(({id}) => ({id}));
  },
  searchMod: state => Boolean(state.fetchFilter.query),
};

export const actions = {
  async list({dispatch, commit, state, getters, rootGetters}, {
    page = 1,
    page_size = 10,
    favorite = false,
    reset = false,
    ...options
  } = {}) {
    commit('SET_LOADING', true);

    switch (state.fetchFilter.type) {
      case 'assigned_me':
        options.filter_assigned = 'me';
        break;
      case 'resolved':
        options.filter_status = ChatStatusResolved;
        break;
      case 'favorite':
        favorite = true;
        break;
    }

    switch (state.fetchFilter.status) {
      case 'all':
        break;
      default:
        options.filter_status = state.fetchFilter.status;
    }

    if (getters.searchMod) {
      options.query = state.fetchFilter.query;
    }

    let apiCall;
    if (options.query) {
      apiCall = axios
        .get(`/chats/api/v1/chats/search`, {params: {page, page_size, ...options}})
        .then(async ({data: {body: {messages = []}}} = {}) => {
          const body = await Promise.all(messages.map(message_last => axios
            .get(`/chats/api/v1/chats/${message_last.chat_id}`, {cache: true})
            .then(({data}) => ({...data, message_last, message_query: message_last, _is_search: true}))));
          return {body};
        });
    } else if (favorite) {
      apiCall = axios
        .get(`/trailer/api/v1/settings`, {
          params: {
            page, page_size,
            key: `favorite.${rootGetters['auth/user'].id}`,
            entity_type: 'chat',
            sort: 'created_at desc',
          },
        })
        .then(async ({data: {Body = []} = {}} = {}) => {
          const body = await Promise.all(Body.map(({entity_id}) => axios
            .get(`/chats/api/v1/chats/${entity_id}`, {cache: true})
            .then(({data}) => data)
            .catch(() => undefined),
          )).then(r => r.filter(r => !!r));
          return {body};
        });
    } else {
      apiCall = axios
        .get(`/chats/api/v1/chats`, {params: {page, page_size, ...options}})
        .then(({data}) => data);
    }

    return apiCall.then(async ({body = []} = {}) => {
      await Promise.all([
        ...body.map(item => axios.get(`/documents/api/v1/clientsenders/${item.clientsender_id}`, {cache: true}).then(({data}) => item.clientsender = data)),
      ]);

      commit('SET_ROOMS', body);
      reset && commit('RESET_LISTS');
      if (getters.searchMod) {
        commit('SET_LIST_CHAT', body);
      } else {
        commit('SET_LIST_BASE', body.map(({id}) => id));
      }

      return body;
    }).catch(error => {
      console.error('state.rooms.list | error = ', error);
      throw error;
    }).finally(() => commit('SET_LOADING', false));
  },
  one({dispatch, commit, state}, {id} = {}) {
    commit('SET_LOADING', true);
    return axios
      .get(`/chats/api/v1/chats/${id}`)
      .then(async ({data: item}) => {
        await Promise.all([
          axios.get(`/documents/api/v1/clientsenders/${item.clientsender_id}`, {cache: true}).then(({data}) => item.clientsender = data),
        ]);
        commit('SET_ROOMS', [item]);
        return item;
      }).catch(error => {
        console.error('api.chat.chat.get | error = ', error);
        throw error;
      }).finally(() => commit('SET_LOADING', false));
  },
  updateCounters({commit}) {
    return;
    return Promise.all([
      axios
        .get(`/chats/api/v1/chats/counters`)
        .then(({data}) => commit('SET_COUNTERS', {name: 'all', ...data})),
      axios
        .get(`/chats/api/v1/chats/counters`, {params: {filter_status: ChatStatusResolved}})
        .then(({data}) => commit('SET_COUNTERS', {name: 'status_resolved', ...data})),
      axios
        .get(`/chats/api/v1/chats/counters`, {params: {filter_assigned: 'me'}})
        .then(({data}) => commit('SET_COUNTERS', {name: 'assigned_me', ...data})),
    ]);
  },
  async assign({commit, state}, {chat_id, user_id} = {}) {
    const isReset = user_id === 'reset';

    let userPromise = Promise.resolve({});
    if (!isReset) {
      userPromise = axios.get(`/entities/api/v1/users/${user_id}`, {cache: true}).then(({data}) => data);
    }

    return Promise
      .all([
        userPromise,
        axios.put(`/chats/api/v1/chats/${chat_id}/assign/${user_id}`),
      ])
      .catch(e => {
        throw e;
      })
      .then(([user, _]) => ({
        user_id: !isReset ? user_id : '', user,
      }))
      .then(({user_id, user}) => {
        commit('SET_ROOMS', [{...state.rooms[chat_id], user_id, user}]);
      });
  },
  setting({commit}) {
    axios.get(`/chats/api/v1/chats/settings`).then(({data}) => commit('SET_SETTING', data));
  },
  start(store, data) {
    return api.chat.chat.start(data).then(response => {
      return response.data;
    }).catch(error => {
      console.error('api.chat.chat.start | error = ', error);
      throw error;
    });
  },
};
